import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../atoms/CloseButton';

import './SelectionToolPanel.scss';

export default function SelectionToolPanel({
    t,
    selectionMode,
    onClearSelection,
    onClosePanel,
    selectedCount = 0,
}) {
    const isRectangleActive = selectionMode === 'rectangle';
    const isLassoActive = selectionMode === 'lasso';
    const isSelectionActive = isRectangleActive || isLassoActive;

    if (!isSelectionActive) {
        return null;
    }

    const title = isRectangleActive
        ? t('discoverPage.selection.rectangleActiveTitle', 'Rectangle selection')
        : t('discoverPage.selection.lassoActiveTitle', 'Lasso selection');
    const selectedLabel = selectedCount > 0
        ? t('discoverPage.selection.selectedTotal', {
            count: selectedCount,
            defaultValue: 'Selected: {{count}}',
        })
        : null;

    return (
        <aside className="selection-tool-panel" aria-label={t('discoverPage.selection.aria', 'Selection tools')}>
            <div className="selection-tool-panel__header">
                <span className="selection-tool-panel__title">
                    {title}
                </span>
                <CloseButton
                    className="selection-tool-panel__close"
                    onClick={onClosePanel}
                    ariaLabel={t('discoverPage.selection.closeAria', 'Close selection tools')}
                />
            </div>
            {selectedLabel && (
                <div className="selection-tool-panel__meta">
                    <span className="selection-tool-panel__badge" aria-live="polite">{selectedLabel}</span>
                </div>
            )}

            <div className="selection-tool-panel__actions">
                <button
                    type="button"
                    className="selection-tool-panel__button"
                    onClick={onClearSelection}
                >
                    {t('discoverPage.selection.clear', 'Clear selection')}
                </button>
            </div>

            <p className="selection-tool-panel__hint">
                {t('discoverPage.selection.hint', 'Hold Shift while drawing to toggle selected markers.')}
            </p>
        </aside>
    );
}

SelectionToolPanel.propTypes = {
    t: PropTypes.func.isRequired,
    selectionMode: PropTypes.string.isRequired,
    onClearSelection: PropTypes.func.isRequired,
    onClosePanel: PropTypes.func.isRequired,
    selectedCount: PropTypes.number,
};
